import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "h-pagination" }

import {ref, onMounted} from "vue";
import {useApp} from "@hview/hview-vue3/packages/hooks";
import {usePagination} from "@hview/hview-vue3/packages";
import {getCertificationListApi} from "@/api/kh";
import {AuditDialog} from "@/components/views/kh";

export default /*@__PURE__*/_defineComponent({
  __name: 'list',
  setup(__props) {

const {loading} = useApp();
const {updatePage, getPagination, totalRow, update, page, reload} = usePagination();

/**
 * 表单数据
 */
const model = ref({});

/**
 * 列表数据
 */
const list = ref([]);

/**
 * 审核弹窗
 */
const auditDialogRef = ref();

/**
 * 表单ref
 */
const formRef = ref();

/**
 * @description 加载数据
 */
const load = () => {
  loading.value = true;
  getCertificationListApi({...getPagination(), ...model.value}).then((res: any) => {
    const {data} = res;
    updatePage(data);
    list.value = data.data;
  }).finally(() => {
    loading.value = false;
  });
}

const resetForm = () => {
  formRef.value.resetFields();
  reload(load);
}

/**
 * @description 打开审核弹窗
 */
const auditEvent = (data: any, type: string) => {
  auditDialogRef.value.open(data.id, type);
}


/**
 * @description 页码改变事件
 */
const paginationChangeEvent = (value: number) => {
  update(value, load);
}

onMounted(() => {
  load();
});



return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_h_dict = _resolveComponent("h-dict")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_h_pagination = _resolveComponent("h-pagination")!
  const _component_h_container = _resolveComponent("h-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_h_container, {
    isTable: "",
    title: "医生审核列表"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_h_pagination, {
          onChange: paginationChangeEvent,
          "current-page": _unref(page),
          total: _unref(totalRow)
        }, null, 8, ["current-page", "total"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          onVnodeBeforeMount: _ctx.onVnodeBeforeMountRef_,
          model: model.value,
          inline: true,
          "label-width": "auto"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "名称",
              prop: "title"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: model.value.title,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model.value.title) = $event)),
                  placeholder: "请输入名称"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "状态",
              prop: "status"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: model.value.status,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model.value.status) = $event)),
                  placeholder: "请选择审核状态",
                  style: {"width":"240px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_h_dict, { dictKey: "audit_type" })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(reload)(load)))
                }, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createTextVNode("查询")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_button, { onClick: resetForm }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode("重置")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onVnodeBeforeMount", "model"])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: list.value,
        stripe: "",
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "id",
            label: "编号",
            "header-align": "center",
            align: "center",
            width: "70"
          }),
          _createVNode(_component_el_table_column, {
            label: "姓名/昵称",
            "header-align": "center",
            align: "center",
            width: "200"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", null, _toDisplayString(scope.row.realname || scope.row.nickname), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "qq",
            label: "所属单位",
            "header-align": "center",
            align: "center",
            width: "200"
          }),
          _createVNode(_component_el_table_column, {
            prop: "works",
            label: "所属科室",
            "header-align": "center",
            align: "center",
            width: "100"
          }),
          _createVNode(_component_el_table_column, {
            prop: "intro",
            label: "擅长领域",
            "header-align": "center",
            align: "center",
            width: "100"
          }),
          _createVNode(_component_el_table_column, {
            prop: "ability",
            label: "工作年限",
            "header-align": "center",
            align: "center",
            width: "100"
          }),
          _createVNode(_component_el_table_column, {
            prop: "status",
            label: "审核状态",
            "header-align": "center",
            align: "center",
            width: "100"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_h_dict, {
                mode: "text",
                dictKey: "audit_type",
                modelValue: scope.row.status,
                "onUpdate:modelValue": ($event: any) => ((scope.row.status) = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "memo",
            label: "拒绝原因",
            "header-align": "center",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "memo",
            label: "操作",
            "header-align": "center",
            align: "center",
            width: "200",
            fixed: "right"
          }, {
            default: _withCtx((scope) => [
              (scope.row.status == 'hidden')
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "primary",
                    onClick: ($event: any) => (auditEvent(scope.row, 'audit')),
                    link: ""
                  }, {
                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                      _createTextVNode("审核")
                    ])),
                    _: 2
                  }, 1032, ["onClick"]))
                : (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    type: "primary",
                    link: "",
                    onClick: ($event: any) => (auditEvent(scope.row, 'detail'))
                  }, {
                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                      _createTextVNode("详情")
                    ])),
                    _: 2
                  }, 1032, ["onClick"]))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, _unref(loading)]
      ]),
      _createVNode(_unref(AuditDialog), {
        ref_key: "auditDialogRef",
        ref: auditDialogRef,
        onVnodeBeforeMount: _ctx.onVnodeBeforeMountRef_,
        onOnLoad: load
      }, null, 8, ["onVnodeBeforeMount"])
    ]),
    _: 1
  }))
}
}

})